


import Game from '../../classes/Game';
import { observer } from "mobx-react-lite"
import { RegionAttachment, TextureAtlasRegion } from '@esotericsoftware/spine-threejs';

export const withGame = (comp: React.FunctionComponent<{game: Game}>) => observer<{ game: Game }>(comp)

export type CustomRegionAttachment = RegionAttachment & { region: TextureAtlasRegion }